import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityFeed,
  addFeedPosts,
  ADD_PAGE,
  SAVE_PAGE,
  TOGGLE_HAS_MORE,
  getGroupFeed,
  TOGGLE_NO_MORE_FEED,
  GET_FEEDS_SUCCESS,
  GET_FEEDS_POSTDATA,
} from "../../redux/actions/userReflection";

import Sidebar from "../../components/Sidebar/Sidebar";
import ButtonBlue from "../../components/Button/ButtonBlue";
import ReflectionCards from "../../components/reflectionCards";

import "../../styles/feed.styles.scss";

import * as AiIcons from "react-icons/ai";
import SearchBar from "../../components/Searchbar";
import axios from "axios";
import { serverUrl, apiUrl } from "../../components/Helpers/Config";
import { staticFiles } from "../../components/Helpers/Static";
import { useLocation, useParams, useHistory } from "react-router-dom";
import PageWrapper from "../PageWrapper";
import SubNavbar from "../../components/Navbar/SubNavbar";
import SharePost from "./SharePost";
import GroupModalShare from "./GroupModalShare";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { AnnounceReader } from "../../components/AnnounceReader";
import Swal from "sweetalert2";
import { useRef } from "react";
import { ViewList, ViewModule } from "@material-ui/icons";
import {
  getUserPreference,
  putUserPreference,
} from "../../redux/actions/commonAction";
import Button from "../../components/Button/Button";
import ButtonCommon from "../../components/Button/ButtonCommon";
import {
  ButtonCommonTopNew,
  ButtonGrid,
  ButtonGridActive,
  ButtonGridNew,
  ButtonGridActiveNew,
} from "../Theme";
import { HiShare } from "react-icons/hi";
import { BiLeftArrowAlt } from "react-icons/bi";
import Loader, { CommunityLoader } from "../../components/Button/Loader";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
function GroupFeed(props) {
  const SIDEBARDATA = [
    {
      title: "Topics",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
    },
    {
      title: "Values/Competencies",
      iconClosed: <AiIcons.AiFillCaretRight />,
      iconOpened: <AiIcons.AiFillCaretDown />,
      item: [],
    },
  ];
  const { groupId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [GroupId, setGroupId] = useState(0);
  const page = useSelector((state) => state.reflections.page);
  const reflections = useSelector((state) => state.reflections.reflections);
  const reflectionsData = useSelector((state) => state.reflections.groupData);
  const loading = useSelector((state) => state.reflections.loading);
  const [hasMore, setHasMore] = useState(false);
  const spage = useSelector((state) => state.reflections.spage);
  const userProfile = useSelector((state) => state.auth.user);
  const pagePreference = useSelector(
    (state) => state.commonData.pagePreference
  );

  const limit = 15;

  const [filterOptions, setFilterOptions] = useState(SIDEBARDATA);
  const [groupedFilterData, setgroupedFilterData] = useState([]);
  const [grouepdValuedata, setGroupedValueData] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    type: -2,
    value: "",
  });
  const [filter, setFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [searchField, setSearchField] = useState("");
  const [filteredPost, setFilteredPost] = useState([]);
  const [showModalShare, setShowModalShare] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [isParent, setIsParent] = useState("");
  const [isAllow, setisAllow] = useState("");
  const [announceRead, setannounceRead] = useState([]);
  const [announceUnRead, setannounceUnRead] = useState([]);
  const [announceList, setannounceList] = useState([]);
  //Nithish added
  const [isLoading, setisLoading] = useState(true);
  const [clearInput, setclearInput] = useState(false);
  const [isGrid, setisGrid] = useState(true);
  const [isMobile, setisMobile] = useState(false);

  const cuurentFilter = useSelector(
    (state) => state.reflections.currentGroupFilter
  );
  useEffect(() => {
    if (cuurentFilter) {
      setSelectedOption(cuurentFilter);
    }
    dispatch({
      type: "groupFilter",
      payload: null,
    });
  }, []);

  const saveFilter = () => {
    dispatch({
      type: "groupFilter",
      payload: selectedOption,
    });
  };

  const getGroupPost = (id) => {
    axios
      .get(serverUrl.Communityv2 + `/group/${id}?limit=${limit}`)
      .then((resp) => {
        if (resp.status === 200) {
          let data = {
            group_name: resp.data?.group_name,
            can_post: resp.data?.can_post,
          };
          const feeds = resp.data?.posts;
          if (feeds.length == limit) {
            setHasMore(true);
          } else {
            setHasMore(false);
          }
          dispatch({
            type: feeds.length < 5 ? TOGGLE_NO_MORE_FEED : GET_FEEDS_SUCCESS,
            payload: { feeds },
          });
          dispatch({
            type: GET_FEEDS_POSTDATA,
            payload: { data },
          });
        }
      })
      .catch((error) => {
        console.log(error, "error fetching posts");
      });
  };

  useEffect(() => {
    getGroupPost(groupId);
    // dispatch(getGroupFeed(groupId));
    axios
      .get(serverUrl.CommunityGroup + "/" + groupId + `/sidebar_filters`)
      .then((resp) => {
        if (resp.status === 200) {
          let currentFilterOptions = [...filterOptions];
          currentFilterOptions[0].item = resp?.data?.topics?.map((item) => ({
            id: item.event_id,
            value: item.event_title,
            count: item.tagged_count || 0,
          }));
          const grouped = Object.values(
            resp?.data?.topics.reduce((acc, curr) => {
              const profileId = curr.profile_id || "Others"; // handle null profile_id
              if (!acc[profileId]) {
                acc[profileId] = {
                  title: curr.profile_name || "Others",
                  iconClosed: <AiIcons.AiFillCaretRight />,
                  iconOpened: <AiIcons.AiFillCaretDown />,
                  item: [],
                  open: false,
                };
              }

              // push event into that profile group
              acc[profileId].item.push({
                id: curr.event_id,
                value: curr.event_title,
                count: curr.tagged_count,
              });

              return acc;
            }, {})
          )
            .filter((group) => group.title !== "Others")
            .sort((a, b) => String(a.title).localeCompare(String(b.title)));
          setgroupedFilterData(grouped);
          currentFilterOptions[1].item = resp?.data?.values.map((item) => ({
            id: item.value_id,
            value: item.value_title,
            count: item.tagged_count || 0,
          }));
          const groupedByVisCat = Object.values(
            resp?.data?.values?.reduce((acc, curr) => {
              const visKey = curr.category_visualization || "Others";
              const catKey = curr.category_title || "Untitled";

              // title format "v3sk: Community"
              const groupKey =
                visKey == "Others" ? "Others" : `${visKey}: ${catKey}`;

              if (!acc[groupKey]) {
                acc[groupKey] = {
                  title: groupKey,
                  iconClosed: <AiIcons.AiFillCaretRight />,
                  iconOpened: <AiIcons.AiFillCaretDown />,
                  open: false,
                  item: [],
                };
              }

              acc[groupKey].item.push({
                id: curr.value_id,
                value: curr.value_title,
                count: curr.tagged_count,
              });

              return acc;
            }, {}) || {}
          )
            .filter((group) => group.title !== "Others")
            .sort((a, b) => String(a.title).localeCompare(String(b.title)));
          setGroupedValueData(groupedByVisCat);
          setFilterOptions(currentFilterOptions);
        }
      });
    callAnnoucement();

    return () => {
      dispatch({ type: SAVE_PAGE });
    };

    //}, [page]);
  }, []);

  useEffect(() => {
    if (groupId != GroupId) {
      setGroupId(groupId);
      getGroupPost(groupId);
      // dispatch(getGroupFeed(groupId));
      callAnnoucement();
    }
  }, [groupId]);

  //Nithish added
  function callAnnoucement() {
    axios
      .get(`${apiUrl}${groupId}/announcements`)
      .then((res) => {
        setannounceList(res.data?.announcements);
        let data = res.data?.announcements?.filter((r) => r.is_read == false);
        let data1 = res.data?.announcements?.filter((r) => r.is_read == true);
        setannounceRead(data);
        setannounceUnRead(data1);
        if (res.data?.announcements?.length === 0) {
          setSelectedOption({ type: -1, value: "" });
        }
        setisLoading(false);
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  }

  const [isloadMore, setIsLoadMore] = useState(false);
  //--------------------------------------------------------------------------------------------------------------------------
  const loadMorePost = () => {
    setIsLoadMore(true);
    const offset = reflections ? reflections.length : 0;
    axios
      .get(
        serverUrl.Community +
          `/group/${groupId}?offset=${offset}&limit=${limit}`
      )
      .then((resp) => {
        if (resp.status === 200) {
          const feedPosts = resp.data;
          if (feedPosts.length > 0) {
            dispatch(addFeedPosts(feedPosts));
          }
          if (feedPosts.length == limit) {
            setHasMore(true);
          } else {
            setHasMore(false);
          }
        }
        setIsLoadMore(false);
      })
      .catch((error) => {
        console.log(error, "Error loading more posts");
        setIsLoadMore(false);
      });
  };

  useEffect(() => {
    // Dropdown
    // setGroupName(reflections.length !== 0 ? reflections[0].is_parent == true ? reflections[0].parent_name : reflections[0].group_name : '')
    setIsParent(reflections.length !== 0 ? reflections[0].is_parent : "");
    setisAllow(reflections.length !== 0 ? reflections[0].user_can_post : "");
    let [eventId, valueId] = [0, 0];
    if (selectedOption.type === 0) {
      eventId = selectedOption.value;
    } else if (selectedOption.type === 1) {
      valueId = parseInt(selectedOption.value);
    }

    if (eventId === 0 && valueId === 0) {
      setFilteredPost(reflections);
    } else {
      setSearchField("");
      filterFeed(eventId, valueId);
    }

    // Search
    // if(searchField.length !== 0){
    //   searchFeed(searchField)
    // }
  }, [selectedOption, reflections]);

  useEffect(() => {
    setGroupName(reflectionsData !== "" ? reflectionsData.group_name : "");
  }, [reflectionsData]);

  const setFilterValue = (type, value) => {
    setSelectedOption({ type, value });
    setSearchField("");
    setclearInput(!clearInput);
    if (type === -2) {
      callAnnoucement();
    }
  };

  const filterFeed = (eventId, valueId) => {
    // setisLoading(true);
    axios
      .post(serverUrl.Community + `/group/${groupId}/filter`, {
        event_id: eventId,
        value_id: valueId,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let filtered = resp.data;

          setFilteredPost(filtered);
          // setisLoading(false);
        }
      });
  };

  const searchFeed = () => {
    if (
      searchField.length != 0 &&
      (selectedOption.type === -1 ||
        selectedOption.type === 1 ||
        selectedOption.type === 0)
    ) {
      axios
        .get(serverUrl.Community + `/group/${groupId}/search/${searchField}`)
        .then((resp) => {
          if (resp.status === 200) {
            let searched = resp.data;
            setFilteredPost(searched);
          }
        });
    } else {
      setFilteredPost(reflections);
    }
    if (searchField.length != 0 && selectedOption.type === -2) {
      axios
        .get(
          `${apiUrl}announcement/group/${groupId}/search/${searchField}` //`${apiUrl}${groupId}/announcement/search/${searchField}`
        )
        .then((resp) => {
          if (resp.status === 200) {
            // let searched = resp.data

            const announceList1 = resp.data?.announcements;
            // setannounceList(announceList1);
            // const announceLists=announceList1.filter((annoucement)=>
            // {
            //   return annoucement.group_id===parseInt(groupId);
            // });

            let data = resp.data.announcements?.filter(
              (r) => r.is_read == false
            );
            let data1 = resp.data.announcements?.filter(
              (r) => r.is_read == true
            );
            setannounceRead(data);
            setannounceUnRead(data1);
            setannounceList(announceList1);
          }
        });

      // setannounceList(res.data.announcements)
    } else {
      callAnnoucement();
    }
  };

  const Loading = ({ active }) => {
    let style = active ? "w-10 h-10" : "hidden w-10 h-10";
    return <img src={staticFiles.loading} alt="loading..." className={style} />;
  };

  //   const goBack = () => {
  //     const prevPage = (location.state && location.state.src) ? location.state.src : '/community/groups';
  //     // const tabId = (location.state && location.state.tabId) ? location.state.tabId : -1;

  //     // if ((tabId > 0) && (postId > 0)) {
  //     //     dispatch(addShowcasePost(tabId, postId))
  //     // }

  //     // history.push(prevPage, { tabId });
  //     history.push(prevPage)
  // }
  //Nithish added---------------------------------------------------------------------------------------
  const handleDelete = (id) => {
    handleDeletePost(id);
  };
  const handleDeletePost = (id) => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure to unshare this Announcement?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(apiUrl + groupId + "/announcement/" + id)
          .then((resp) => {
            if (resp.status === 200) {
              callAnnoucement();
            }
          })
          .catch((error) => {
            console.error("Error deleting announcement:", error);
          });
      }
    });
  };

  useEffect(() => {
    dispatch(getUserPreference());
    const interval = setInterval(() => {
      resize();
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const resize = () => {
    if (window.innerWidth < 550) {
      setisMobile(true);
      setisGrid(false);
    } else {
      setisMobile(false);
      let data = localStorage.getItem("is_grid") == "true" ? true : false;
      setisGrid(data);
    }
  };

  useEffect(() => {
    if (props.location?.state?.active == true) {
      let data = pagePreference["groups_active_is_grid"];
      setisGrid(data);
      localStorage.setItem("is_grid", data);
    }
    if (props.location?.state?.active == false) {
      let data = pagePreference["groups_archive_is_grid"];
      setisGrid(data);
      localStorage.setItem("is_grid", data);
    }
  }, [pagePreference]);

  const updatePreference = (data) => {
    if (isGrid != data) {
      if (props.location?.state?.active == true) {
        pagePreference["groups_active_is_grid"] = !isGrid;
      }
      if (props.location?.state?.active == false) {
        pagePreference["groups_archive_is_grid"] = !isGrid;
      }
      localStorage.setItem("is_grid", !isGrid);
      setisGrid(!isGrid);
      dispatch(putUserPreference(pagePreference));
    }
  };

  //---------------------------------------------------------------------------------------------------------------------

  return (
    <PageWrapper>
      {isLoading ? ( // Nithish added
        <Loader />
      ) : (
        <>
          <div className="cardBackgroundColor border20px shadow-sm">
            <div className="overflow-hidden pt-5">
              <div className="flex flex-col sm:flex-row pb-4 px-5 border-bottom-f1">
                {/* <ButtonCommonTopNew
                  className="rounded-lg px-5 py-2 flex items-center w-max cursor-pointer"
                  onClick={() => history.push("/community/groups")}
                >
                  <BiLeftArrowAlt className="w-5 h-5" />
                  <h1 className="text-xs lg:text-sm">Back</h1>
                </ButtonCommonTopNew> */}
                <div
                  className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                  onClick={() => history.push("/community/groups")}
                >
                  <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
                  <h1 className="text-lg blueColor font-semibold">Back</h1>
                </div>
                <p className="text-xl flex justify-center items-center w-full font-semibold blackColor">
                  {groupName}
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
              <div className="flex flex-row-reverse lg:flex-col border-right-f1">
                <div className="w-full border-bottom-f1 p-4 box-border">
                  <SearchBar
                    setSearchField={setSearchField}
                    clear={clearInput}
                    onClick={searchFeed}
                  />
                </div>
                <Sidebar
                  data={filterOptions}
                  selectedOption={selectedOption}
                  setSelectedOption={setFilterValue}
                  announceList={announceList}
                  isAnnounce={true}
                  groupedFilterData={groupedFilterData}
                  grouepdValuedata={grouepdValuedata}
                  groupId={groupId}
                />
              </div>
              <div className="w-full backGroundColor pb-6">
                <div className="flex justify-between lg:justify-end cardBackgroundColor p-4 pb-4 mb-4 px-5 items-center gap-2">
                  {userProfile?.role == "MANAGER" && (
                    <div className="" id="hideDropDown">
                      <ButtonCommonTopNew
                        className="flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer"
                        onClick={() =>
                          history.push("/community/addannouncement", groupId)
                        }
                      >
                        Make Announcement
                      </ButtonCommonTopNew>
                    </div>
                  )}
                  {isParent == true || reflectionsData?.can_post == false ? (
                    ""
                  ) : (
                    <div className="" id="hideDropDown">
                      <ButtonCommonTopNew
                        className="flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer"
                        onClick={() => setShowModalShare(true)}
                      >
                        <HiShare
                          fontSize="small"
                          className="w-4 h-4 cursor-pointer primaryIcon"
                        />
                        Share Post
                      </ButtonCommonTopNew>
                    </div>
                  )}
                  <div className="">
                    <div
                      className={`p-1 rounded-lg flex items-center ${
                        isGrid == false
                          ? "bg-blurred-gradient"
                          : "bg-blurred-gradientright"
                      } ${"cursor-pointer"}`}
                    >
                      {isMobile == false ? (
                        isGrid == true ? (
                          <ButtonGridActiveNew
                            className="grid-div"
                            onClick={() => {
                              updatePreference(true);
                            }}
                          >
                            <ViewModule className={`${"gridicon-styleNew"}`} />
                          </ButtonGridActiveNew>
                        ) : (
                          <ButtonGridNew
                            className="grid-div"
                            onClick={() => updatePreference(true)}
                          >
                            <ViewModule className={`${"gridicon-styleNew"}`} />
                          </ButtonGridNew>
                        )
                      ) : (
                        ""
                      )}
                      {isGrid == false ? (
                        <ButtonGridActiveNew
                          className="grid-div"
                          onClick={() => updatePreference(false)}
                        >
                          <ViewList className={`${"listicon-styleNew"}`} />
                        </ButtonGridActiveNew>
                      ) : (
                        <ButtonGridNew
                          className="grid-div"
                          onClick={() => updatePreference(false)}
                        >
                          <ViewList className={`${"listicon-styleNew"}`} />
                        </ButtonGridNew>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  class={`${
                    isGrid == true
                      ? "grid-cols-2"
                      : "grid-cols-1 justify-items-center"
                  } ${"grid gap-4 px-5"}`}
                >
                  {userProfile?.role == "MANAGER" &&
                    selectedOption.type === -2 &&
                    announceList &&
                    announceList?.map((item) => (
                      <AnnounceReader
                        gridView={isGrid}
                        data={item}
                        groupId={groupId}
                        key={item.announcement_id}
                        handleDelete={handleDelete}
                        isAccess={userProfile?.role}
                      />
                    ))}

                  {userProfile?.role != "MANAGER" &&
                    selectedOption.type === -2 &&
                    announceRead &&
                    announceRead?.map((item) => (
                      <AnnounceReader
                        gridView={isGrid}
                        data={item}
                        groupId={groupId}
                        key={item.announcement_id}
                        handleDelete={handleDelete}
                        isAccess={userProfile?.role}
                      />
                    ))}
                  {selectedOption.type !== -2 &&
                    filteredPost &&
                    filteredPost.map((item) => (
                      <ReflectionCards
                        item={item}
                        key={item.reflection_id}
                        isView={false}
                        gridView={isGrid}
                        saveFilter={saveFilter}
                      />
                    ))}
                  {userProfile?.role != "MANAGER" &&
                    selectedOption.type === -2 &&
                    announceUnRead &&
                    announceUnRead?.map((item) => (
                      <AnnounceReader
                        gridView={isGrid}
                        data={item}
                        groupId={groupId}
                        key={item.announcement_id}
                        handleDelete={handleDelete}
                        isAccess={userProfile?.role}
                      />
                    ))}
                </div>
                <div className="grid grid-cols-1 mt-6">
                  <div className="justify-center justify-self-center">
                    {/* <Loading active={loading} /> */}
                    {loading && <CommunityLoader />}
                    {hasMore && selectedOption?.type == -1 && (
                      <ButtonCommonTopNew
                        className={`px-5 border p-2 text-sm rounded-lg ${
                          isloadMore ? "" : "cursor-pointer"
                        }`}
                        onClick={!isloadMore ? loadMorePost : null}
                      >
                        {isloadMore ? "Loading..." : "Load more"}
                        {/* Load more */}
                      </ButtonCommonTopNew>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <GroupModalShare
        groupId={groupId}
        show={showModalShare}
        setShow={setShowModalShare}
        getGroupPost={getGroupPost}
      />
    </PageWrapper>
  );
}

export default GroupFeed;
